import { render, staticRenderFns } from "./BaseInfoForm.vue?vue&type=template&id=4c4c022c&scoped=true&"
import script from "./BaseInfoForm.vue?vue&type=script&lang=ts&"
export * from "./BaseInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInfoForm.vue?vue&type=style&index=0&id=4c4c022c&lang=stylus&scoped=true&"
import style1 from "./BaseInfoForm.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c022c",
  null
  
)

export default component.exports